import { useRef, useCallback } from 'react';

export const useMetadataManager = () => {
  const metadataRef = useRef({});

  const stageTickets = useCallback((tickets) => {
    const modifiedTickets = tickets.filter((ticket) => ticket.isModified === true);

    if (modifiedTickets.length === 0) {
      delete metadataRef.current.bet_tickets;
      return;
    }

    metadataRef.current.bet_tickets = modifiedTickets.map(
      // eslint-disable-next-line no-unused-vars
      ({ initialEditMode, potential_payout, isModified, ...ticket }) => ticket
    );
  }, []);

  const stageLotteryId = useCallback((lotteryId) => {
    metadataRef.current.selected_lottery_id = lotteryId;
  }, []);

  const stageLotteryList = useCallback((lotteries) => {
    if (!lotteries.length) {
      delete metadataRef.current.searched_lotteries;
      return;
    }
    metadataRef.current.searched_lotteries = lotteries;
  }, []);

  const hasMetadata = useCallback(() => Boolean(
    metadataRef.current.bet_tickets?.length
      || metadataRef.current.selected_lottery_id
      || metadataRef.current.searched_lotteries?.length
  ), []);

  const collectMetadata = useCallback(() => {
    if (!hasMetadata()) return undefined;
    return { ...metadataRef.current };
  }, [hasMetadata]);

  const clearMetadata = useCallback(() => {
    metadataRef.current = {};
  }, []);

  return {
    stageTickets,
    stageLotteryId,
    stageLotteryList,
    collectMetadata,
    clearMetadata,
    hasMetadata,
  };
};
